import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-partner-login',
  templateUrl: './partner-login.component.html',
  styleUrls: ['./partner-login.component.scss']
})
export class PartnerLoginComponent implements OnInit {
  username: string;
  password: string;
  constructor(private _authenticationService: AuthenticationService,   private router: Router,) { }

  ngOnInit() {
  }

  // This method used for admin login
  login(loginForm: NgForm) {   
    //this.loading = true; 
    this._authenticationService.partnerLogin(loginForm.value.username, loginForm.value.password)
      .subscribe(
        data => {                  
          if (data.returnCode == 0) {                         
            localStorage.setItem('currentUser', JSON.stringify({ token: data.responsetoken, userDetail: data.response.userDetail }));                
            this.router.navigate(['partnerDashboard']);
          }
          else{
            console.log(data)
            alert(data.returnMsg)
          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/partnerUI/partner-login/partner-login.component.ts